import BurgerMenuItem from './BurgerMenuItem';

export default BurgerMenuItem;
